import React from 'react';
import { Link } from 'react-router-dom';

import useDragScroll from 'utils/hooks/useDragScroll';
import { Category, VideoProduct, videoProductToRoute } from 'helper/videos';

// Abas de categoria em estilo "sublinhado" (proposital, para comparar com o
// SectionTabs de pills usado nas outras seções). Categorias vêm da API.
export default function CategoryTabs({
  categories,
  product,
  activeId,
}: {
  categories: Category[];
  product: VideoProduct;
  activeId: number;
}) {
  const productRoute = videoProductToRoute[product];
  const {
    ref,
    dragHandlers: {
      onPointerDown, onPointerMove, onPointerUp, onPointerLeave, onClickCapture,
    },
  } = useDragScroll<HTMLDivElement>();

  return (
    <div
      className="videos-mobile-tabs"
      ref={ref}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={onPointerUp}
      onPointerLeave={onPointerLeave}
      onClickCapture={onClickCapture}
    >
      {categories.map((category) => (
        <Link
          key={category.id}
          to={`${productRoute}/categories/${category.id}`}
          className={`videos-mobile-tab${category.id === activeId ? ' active' : ''}`}
        >
          {category.label}
        </Link>
      ))}
    </div>
  );
}
